import lodashSortBy from 'lodash/sortBy';

import { WorkspaceChainFragment } from '@/sections/Overview/Chains/__generated__/fragments.generated';
import moment from 'moment';

import { productionStatusSortOrder } from '../constants';
import { SortBy } from '../types';

function getChainWithDeployments(chain: WorkspaceChainFragment) {
  return chain.deploymentCountByStatus.reduce((acc, { count }) => acc + count, 0) > 0;
}

function getChainsWithDeployments(chains: WorkspaceChainFragment[]) {
  return Object.values(chains).filter(getChainWithDeployments);
}

function sortChains(chains: WorkspaceChainFragment[], sortBy: SortBy) {
  switch (sortBy) {
    case SortBy.RECENTLY_ACTIVE:
      return lodashSortBy(chains, (chain) => moment(chain.lastActivity).valueOf()).reverse();
    case SortBy.PRODUCTION:
      return lodashSortBy(chains, [
        (chain) => {
          if (!chain.primaryDeployment) return productionStatusSortOrder.length;
          if (!chain.primaryDeployment.isPrimary) return productionStatusSortOrder.length - 3.5;

          return productionStatusSortOrder.indexOf(chain.primaryDeployment.status);
        },
        (chain) => -moment(chain.lastActivity).valueOf(),
      ]);
    case SortBy.CREATED:
      return lodashSortBy(chains, (chain) => moment(chain.created).valueOf()).reverse();
    default:
      return lodashSortBy(chains, (chain) => moment(chain.lastActivity).valueOf()).reverse();
  }
}

export { getChainsWithDeployments, sortChains, getChainWithDeployments };
